import gql from 'graphql-tag';

import suggestedSyncFolderRemoteItemFragment from '../fragments/suggestedSyncFolderRemoteItemFragment';

export const querySuggestedSyncFolderRemoteItems = gql`
  query suggestedSyncFolderRemoteItems(
    $credentialID: DokkioID
    $refresh: Boolean
  ) {
    suggestedSyncFolderRemoteItems(
      credentialID: $credentialID
      refresh: $refresh
    ) {
      ...suggestedSyncFolderRemoteItemFragment
    }
  }
  ${suggestedSyncFolderRemoteItemFragment}
`;

export default querySuggestedSyncFolderRemoteItems;
